import React, {useState} from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {Drawer, ListItem, ListItemAvatar, Avatar, List, ListItemText, ListItemIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {PermIdentity, ExitToApp, SlowMotionVideo} from '@material-ui/icons';

import BackendApi from '../BackendApi';
import CookieStor from '../CookieStor'

import logo from '../media/img/logo.svg'

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 256,
    flexShrink: 0,
  },
  drawerPaper: {
    width: 256,
    background: '#FAFAFA',
    boxShadow: '0px 5.5px 5px rgba(0, 0, 0, 0.24), 0px 9px 18px rgba(0, 0, 0, 0.18)',
  },

  drawerHead: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  
  accountLabel: {
    backgroundColor: '#F0F0F0',
    padding: 0,
    marginBottom: theme.spacing(1),
  },
  
  accountItem: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  
  accountText: {
    fontSize: '12px',
    color: '#666666',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
 
  linkItem: {
    fontSize: '14px',
  },
  
  listItem: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  
  itemIcon: {
    minWidth: 'auto',
    paddingRight: theme.spacing(2),
  },
}));

var menuType = 'permanent'

if(window.innerWidth >= 960) {
  menuType = 'permanent'
} else {
  menuType = 'temporary'
}

function Menu(props) {
  
  const classes = useStyles();

  const [username, setUsername] = useState('');


  BackendApi.getProfile().then((result) => {
    switch(result.status)
      {
        case 200:
          setUsername(result.data.username);
          break;
        
        case 401:
          CookieStor.setAccessToken('');
          CookieStor.setRefreshToken('');
          this.props.history.push('/');
          break;
        
        default:
          console.log('Ошибка сервера')
      }
  })
 
  return (
    <Drawer
      className={classes.drawer}
      variant = {menuType}
      anchor='left'
      logo={logo}
      open={props.openMenu}
      onClose= {props.handleDrawerClose}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.drawerHead}>
        <Link to='/'><img src={logo} alt='Логотип' /></Link>
      </div>
      <div className={classes.accountLabel}>
        <ListItem className={classes.accountItem}>
          <ListItemAvatar>
            <Avatar style={{background: 'linear-gradient(0deg, #E2E2E2, #E2E2E2)'}}>
              <PermIdentity style={{color: '#666666'}}/>
            </Avatar>
          </ListItemAvatar>
          <ListItemText 
            classes={{
              primary: classes.accountText,
            }} 
            primary={username}/>
        </ListItem>
      </div>
      <List component="nav" aria-label="main mailbox folders">        
        <ListItem  className={classes.listItem} button component={RouterLink} to="/video-list">
          <ListItemIcon className={classes.itemIcon}>
            <SlowMotionVideo style={{color: '#90C71A'}} />
          </ListItemIcon>
          <ListItemText classes={{
              primary: classes.linkItem,
            }} 
            primary="Видеоуроки" 
            style={{color: '#90C71A'}}
          />
        </ListItem>
        <ListItem className={classes.listItem} button onClick= {props.logout}>
          <ListItemIcon className={classes.itemIcon}>
            <ExitToApp style={{color: '#666666'}} />
          </ListItemIcon>
          <ListItemText classes={{
              primary: classes.linkItem,
            }} 
            primary="Выход" 
            style={{color: '#666666'}}
          />
        </ListItem>
      </List>
    </Drawer>
  );
}


export default Menu;
